import { TFunction } from 'react-i18next';
import { AuthorityEnum } from 'src/shared/models/enums/authority.enum';

const authorityKeys: Record<AuthorityEnum, string> = {
  [AuthorityEnum.Extern]: 'helpArticles:authority.extern',
  [AuthorityEnum.Guest]: 'helpArticles:authority.guest',
  [AuthorityEnum.User]: 'helpArticles:authority.user',
  [AuthorityEnum.Privileged]: 'helpArticles:authority.privileged',
  [AuthorityEnum.Administrator]: 'helpArticles:authority.administrator',
  [AuthorityEnum.SuperAdmin]: 'helpArticles:authority.superAdmin',
};

export const getAuthorityLabel = (authority: number, t: TFunction): string => {
  const key = authorityKeys[authority as AuthorityEnum];
  return key ? t(key) : String(authority);
};

export const authorityOptions = (t: TFunction): { id: AuthorityEnum; name: string }[] =>
  Object.values(AuthorityEnum)
    .filter((value): value is AuthorityEnum => typeof value === 'number')
    .map((id) => ({ id, name: getAuthorityLabel(id, t) }));
